// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1CQFc","col":"CardReaderDesc_col__sXLXH","label":"CardReaderDesc_label__16gx7"};